// extracted by mini-css-extract-plugin
module.exports = {"input":"MaskedInput_input__1Qyl_","label":"MaskedInput_label__1xka7","textContainer":"MaskedInput_textContainer__1ek1O"};